import { Box, Grid } from "@mui/material";
import { FormikProps } from "formik";
import CustomDatePicker from "../../../../../components/CustomDatePicker";
import { SlotData } from "../../../../../constants/provider/availability";
// import TimeSlotDropdown from "../../../../../constants/provider/InterdependentDropdowns";
// import Text from "../../../../../components/Text";
import dayjs from "dayjs";
import DeleteIcon from "../../../../../components/app/DeleteIcon";
import {
  setTimeToFixedAfternight,
  setTimeToFixedMidnight,
} from "../../../../../utils/utils";

interface BlockDaysViewProps {
  formik: FormikProps<SlotData>;
  onDeleteClick?: (ind: number) => void;
}

const BlockDaysView = ({ formik, onDeleteClick }: BlockDaysViewProps) => {
  return formik.values?.blockDays?.map((blockData, ind) => {
    // const dateError = (formik.errors.blockDays?.[ind] as any)?.date;
    const startTimeError = (formik.errors.blockDays?.[ind] as any)?.startTime;
    // const endTimeError = (formik.errors.blockDays?.[ind] as any)?.endTime;

    return (
      <Grid container spacing={2} key={ind} item xs={4}>
        <Grid item xs={9}>
          <Box width={"100%"} mb={2}>
            <CustomDatePicker
              minDate={dayjs(new Date())}
              error={startTimeError}
              label="Date"
              value={blockData?.startTime}
              onChange={(val) => {
                // formik.setFieldValue(`blockDays[${ind}].date`, val);
                formik.setFieldValue(
                  `blockDays[${ind}].startTime`,
                  setTimeToFixedMidnight(val as any)
                );
                formik.setFieldValue(
                  `blockDays[${ind}].endTime`,
                  setTimeToFixedAfternight(val as any)
                );
              }}
            />
          </Box>
        </Grid>
        {/* <Grid item xs={6}>
          <TimeSlotDropdown
            fullDay={blockData.fullDay}
            startTime={blockData.startTime}
            endTime={blockData.endTime}
            setStartTime={(val) => {
              formik.setFieldValue(`blockDays[${ind}].startTime`, val);
            }}
            setEndTime={(val) => {
              formik.setFieldValue(`blockDays[${ind}].endTime`, val);
            }}
            startTimeError={startTimeError}
            endTimeError={endTimeError}
          />
        </Grid> */}
        <Grid item xs={2}>
          {/* <FormControlLabel
            control={
              <Checkbox
                checked={blockData?.fullDay}
                onChange={(e) => {
                  if (e.currentTarget.checked) {
                    formik.setFieldValue(
                      `blockDays[${ind}].startTime`,
                      "00:00:00"
                    );
                    formik.setFieldValue(
                      `blockDays[${ind}].endTime`,
                      "23:45:00"
                    );
                  } else {
                    formik.setFieldValue(`blockDays[${ind}].startTime`, "");
                    formik.setFieldValue(`blockDays[${ind}].endTime`, "");
                  }

                  formik.setFieldValue(
                    `blockDays[${ind}].fullDay`,
                    e.target.checked
                  );
                }}
              />
            }
            label={<Text>Full Day</Text>}
          /> */}
          <DeleteIcon onClick={() => onDeleteClick?.(ind)} />
        </Grid>
      </Grid>
    );
  });
};

export default BlockDaysView;
